/**
 * ThreeDBasemapNotice
 *
 * Shown inside the basemap group of the layers panel (authenticated and public
 * variants) while 3D terrain mode is active. In 3D the basemap is locked to the
 * vector terrain style and the `BasemapSwitcher` is disabled, so this explains
 * why and offers a one-click way back to 2D. Reads `map.is3DMode` /
 * `map.toggle3DMode` from the store itself — consumers just mount it.
 *
 * @module components/layers/ThreeDBasemapNotice
 */
import { memo } from 'react';
import { Alert, Button, Text } from '@mantine/core';
import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useGeoMarkupStore } from '@/store';

const NOTICE_ICON_SIZE = 16;

export const ThreeDBasemapNotice = memo(function ThreeDBasemapNotice() {
  const { t } = useTranslation();
  const is3DMode = useGeoMarkupStore((state) => state.map.is3DMode);
  const toggle3DMode = useGeoMarkupStore((state) => state.map.toggle3DMode);

  if (!is3DMode) return null;

  return (
    <Alert
      variant="light"
      color="yellow"
      icon={<Info size={NOTICE_ICON_SIZE} />}
      mb="sm"
    >
      <Text size="xs">{t('layers.basemap.threeDNotice')}</Text>
      <Button
        variant="subtle"
        size="compact-xs"
        color="yellow"
        onClick={toggle3DMode}
        mt="xs"
      >
        {t('layers.basemap.disable3D')}
      </Button>
    </Alert>
  );
});
